import { render, staticRenderFns } from "./VxReadMore.vue?vue&type=template&id=3bb4d258&scoped=true&"
import script from "./VxReadMore.vue?vue&type=script&lang=js&"
export * from "./VxReadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb4d258",
  null
  
)

export default component.exports